<p-panel header="Filtrer les produits" [toggleable]="true">
    <ng-template #icons>
        <p-button label="Réinitialiser" icon="pi pi-undo" iconPos="right" (click)="onClear()" text />
    </ng-template>
    <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12 sm:col-span-6 md:col-span-4 2xl:col-span-3">
            <p-select [options]="brands" [(ngModel)]="filters.brands" optionLabel="nom" [filter]="true" fluid filterBy="nom" [showClear]="true" [loading]="false" [lazy]="true" [showClear]="true" placeholder="Marque" (onFilter)="onBrandFilter($event)" (onChange)="onSelectChange($event)" />
        </div>

        <div class="col-span-12 sm:col-span-6 md:col-span-4 2xl:col-span-3">
            <p-select [options]="references" [(ngModel)]="filters.references" [filter]="false" fluid [showClear]="true" [loading]="false" [lazy]="true" [showClear]="true" [editable]="true" placeholder="Référence" (onChange)="onSelectReferenceChange($event)" />
        </div>

        <div class="col-span-12 sm:col-span-6 md:col-span-4 2xl:col-span-3">
            <input type="number" pInputText [(ngModel)]="filters.ids" (input)="onInput()" autocomplete="off" fluid placeholder="Identifiant" />
        </div>

        <div class="col-span-12 sm:col-span-6 md:col-span-4 2xl:col-span-3">
            <p-multiselect class="multiselect-stocks" [options]="states" [(ngModel)]="filters.states" [showToggleAll]="false" [filter]="false" placeholder="États" optionLabel="name" display="chip" fluid (onChange)="onMultiSelectChange($event)">
                <ng-template let-selectedStates pTemplate="selecteditems">
                    @for (state of selectedStates; track $index) {
                        <p-tag [severity]="state.severity" [value]="state.name" />
                    }
                </ng-template>
                <ng-template let-state pTemplate="item">
                    <p-tag [severity]="state.severity" [value]="state.name" />
                </ng-template>
            </p-multiselect>
        </div>
        
        <div class="col-span-12 sm:col-span-6 md:col-span-4 2xl:col-span-3">
            <p-select class="multiselect-stocks" [options]="stocks" [(ngModel)]="filters.stocks" [filter]="false" fluid [showClear]="true" placeholder="Stock Ebay" optionLabel="name" display="chip" fluid (onChange)="onSelectChange($event)">
                <ng-template let-selectedStocks #selectedItem>
                    @if (selectedStocks) {
                        <p-tag [severity]="utilityService.getEbaySeverity(selectedStocks)" [value]="utilityService.getEbayLabel(selectedStocks, true)" />
                    }
                </ng-template>
                <ng-template let-stock #item>
                    <p-tag [severity]="utilityService.getEbaySeverity(stock)" [value]="utilityService.getEbayLabel(stock, false)" />
                </ng-template>
            </p-select>
        </div>
        
        <div class="col-span-12 sm:col-span-6 md:col-span-4 2xl:col-span-3">
            <p-select class="multiselect-stocks" [options]="quantities" [(ngModel)]="filters.quantities" [filter]="false" fluid [showClear]="true" placeholder="Quantité" optionLabel="name" display="chip" fluid (onChange)="onSelectChange($event)">
                <ng-template let-selectedQuantities #selectedItem>
                    @if (selectedQuantities) {
                        <p-tag [severity]="utilityService.getQuantitySeverity(selectedQuantities)" [value]="utilityService.getQuantityLabel(selectedQuantities, true)" />
                    }
                </ng-template>
                <ng-template let-quantity #item>
                    <p-tag [severity]="utilityService.getQuantitySeverity(quantity)" [value]="utilityService.getQuantityLabel(quantity, false)" />
                </ng-template>
            </p-select>
        </div>

        <div class="col-span-12 md:col-span-8 2xl:col-span-6 flex items-center gap-4">
            <div class="sm:shrink">
                <p-inputnumber [(ngModel)]="minPrice" (input)="onInput()" [inputSize]="5" suffix=" €" inputId="price-min" mode="decimal" [min]="0" [max]="this.maxLimit" />
            </div>
            <div class="hidden sm:block sm:grow">
                <p-slider [(ngModel)]="priceRange" [range]="true" [min]="0" [max]="this.maxLimit" (onChange)="onChange()" />
            </div>
            <div class="sm:shrink">
                <p-inputnumber [(ngModel)]="maxPrice" (input)="onInput()" [inputSize]="6" [suffix]="maxPrice == this.maxLimit ? ' €+' : ' €'"  inputId="price-max" mode="decimal" [min]="0" [max]="this.maxLimit" />
            </div>
        </div>
    </div>
    @if (showGamme || showCategory || showSubCategory) {
        <p-divider type="solid" align="center">
            <b>Colonnes Suplémentaires</b>
        </p-divider>
        <div class="grid grid-cols-12 gap-4">
            @if (showGamme) {
                <div class="col-span-12 sm:col-span-6 md:col-span-4 2xl:col-span-3">
                    <p-select [options]="gammes" [(ngModel)]="filters.gammes" optionLabel="nom" [filter]="true" fluid filterBy="nom" [showClear]="true" [loading]="false" [lazy]="true" [showClear]="true" placeholder="Gamme" (onFilter)="onGammeFilter($event)" (onChange)="onSelectChange($event)" />
                </div>
            }
            @if(showCategory) {
                <div class="col-span-12 sm:col-span-6 md:col-span-4 2xl:col-span-3">
                    <p-select [options]="categories" [(ngModel)]="filters.categories" optionLabel="nom" [filter]="true" fluid filterBy="nom" [showClear]="true" [loading]="false" [lazy]="true" [showClear]="true" placeholder="Catégorie" (onFilter)="onCategoryFilter($event)" (onChange)="onSelectChange($event)" />
                </div>
            }
            @if(showSubCategory) {
                <div class="col-span-12 sm:col-span-6 md:col-span-4 2xl:col-span-3">
                    <p-select [options]="subCategories" [(ngModel)]="filters.subCategories" optionLabel="nom" [filter]="true" fluid filterBy="nom" [showClear]="true" [loading]="false" [lazy]="true" [showClear]="true" placeholder="Sous-catégorie" (onFilter)="onSubCategoryFilter($event)" (onChange)="onSelectChange($event)" />
                </div>
            }
        </div>
    }
</p-panel>